import type { Optional } from '@festina-life/core'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import {
  type PropsWithChildren,
  type ReactNode,
  useEffect,
  useState,
} from 'react'

import { HoverMenuItem } from './HoverMenuItem'

type HoverPopoverListProps<Element> = PropsWithChildren & {
  elements: Element[]
  renderLabel: (element: Element) => ReactNode | null
  renderHover: (element: Element) => ReactNode | null
  labelClassName?: string
  hoverClassName?: string
  filterValue?: Optional<string>
}

export const HoverMenuList = <Element,>({
  elements,
  renderLabel,
  renderHover,
  labelClassName,
  filterValue,
  children,
}: HoverPopoverListProps<Element>) => {
  const [activeIndex, setActiveIndex] = useState(-1)

  useEffect(() => {
    setActiveIndex(filterValue ? 0 : -1)
  }, [filterValue])

  return (
    <div className="flex h-full">
      <div
        className={cx(
          'max-h-[45vh] min-w-[35em] max-w-[50em] overflow-auto',
          paperStyles({ isFaded: false, borders: ['right'] }),
        )}
      >
        {children}
        <div className=" divide-y divide-gray-100 dark:divide-gray-600 ">
          {elements.map((element: Element, index) => (
            <HoverMenuItem
              // oxlint-disable-next-line react/no-array-index-key -- we don't have a unique key
              key={index}
              onFocus={() => setActiveIndex(index)}
              onMouseEnter={() => setActiveIndex(index)}
              onBlur={() => setActiveIndex(-1)}
              isActive={index == activeIndex}
              label={renderLabel(element)}
              labelClassName={labelClassName}
            />
          ))}
        </div>
      </div>
      {elements.map(
        (element, index) =>
          activeIndex === index && (
            // oxlint-disable-next-line react/no-array-index-key -- we don't have a unique key
            <div className="p-2 " key={index}>
              <div className="flex h-full max-h-[45vh] min-w-[35em] flex-col ">
                {renderHover(element)}
              </div>
            </div>
          ),
      )}
    </div>
  )
}
